import * as React from 'react';
import InputErrorClass from 'src/components/Shared/InputErrorClass';

export default class SearchBox extends React.Component<any, any> {
  public render() {
    const { values, handleChange, errors } = this.props;

    return (
      <div>
        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Buscador</label>
              <select
                className={InputErrorClass({ errors, name: 'data.search' })}
                name="data.search"
                onChange={handleChange}
                value={values.data.search}
              >
                <option value="">Seleccioná una opcion</option>
                <option value="packages">Paquetes</option>
                <option value="flights">Aereos</option>
                <option value="hotels">Hoteles</option>
                <option value="activities">Actividades</option>
                <option value="transfers">Traslados</option>
                <option value="multiple">Multiple</option>
              </select>
              {errors['data.search'] && <p className="invalid-feedback">{errors['data.search']}</p>}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Module/Types/SearchBox.tsx